import { EuiFlexGroup, EuiFlexItem,EuiLoadingSpinner, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiOverlayMask } from '@elastic/eui';
import React, { useMemo, useState } from 'react';
import "./styles.css";

interface Props{
  onClose(refresh?:boolean):any;
  isOpen?: boolean;
  title: string;
  content?: JSX.Element;
  className?:string;
  contentFooter?: any;
}

export const ModalApp = (props:Props) =>{

  let {title, content, onClose, contentFooter, className, isOpen} = props;

  let [loaded, setLoaded] =  useState(false);

  const loader = (
  <EuiFlexGroup justifyContent='center' alignItems='center'>
    <EuiFlexItem grow={false}><EuiLoadingSpinner size='xl'/></EuiFlexItem>
  </EuiFlexGroup>
  )
  
  const getFooter = useMemo(() =>{
    if(contentFooter){
      return(
        <EuiModalFooter>
          {contentFooter}
        </EuiModalFooter>
      )
    }
  },[contentFooter])

  const close = () => {
    onClose && onClose();
  }

  const isLoaded = () => {
    if(document.getElementsByClassName("modalApp")!==null)
    {
      setLoaded(true);
    }
  }

  const getContent = useMemo(() => {
    if(loaded){
      return content ? content : loader;
    }else{
      isLoaded()
      return null
    }
  },[loaded,content,isLoaded])

  // const getContent = () => {
  //   if(loaded){
  //     return content;
  //   }else{
  //     isLoaded()
  //     return null
  //   }
  // }

  return isOpen ? (
    <EuiOverlayMask>
      <EuiModal id="modalApp" onClose={close} className={className ? className : "modalApp"} maxWidth={false}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>{title}</EuiModalHeaderTitle>
        </EuiModalHeader>
        <EuiModalBody>
          {getContent}
        </EuiModalBody>
        { getFooter }
      </EuiModal>
    </EuiOverlayMask>
  ) : null
}
export default ModalApp;